import type { ReactNode } from "react";
import { Brand } from "@/components/Brand";

// Centered narrow column shared by the auth screens (login, forgot/reset) so
// they share one look (DRY). Mobile-first: full-width with side padding on a
// small screen, capped to a readable card width from `sm:` up.
export function AuthLayout({
  title,
  description,
  children,
  footer,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <section className="mx-auto flex w-full max-w-sm flex-col gap-6 py-8 sm:py-12">
      {/* White card so the form stays legible on the dark pre-login backdrop. */}
      <div className="flex flex-col gap-6 rounded-xl border border-brk-border bg-brk-panel p-6 text-brk-text shadow-lg sm:p-8">
        <div className="flex flex-col items-center gap-4 text-center">
          <Brand size="lg" onLight />
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          {description && <p className="text-sm text-brk-dim">{description}</p>}
        </div>
        {children}
        {footer && (
          <div className="text-center text-sm text-brk-dim">{footer}</div>
        )}
      </div>
    </section>
  );
}
